module.exports = __webpack_public_path__ + "img/logo_bisnis_asia.5b55ede1.png";